import React, { useEffect, useMemo, useState } from "react";

import { CYCLING_PLACEHOLDERS } from "@v2/features/home/components/prompt-suggestions/placeholders";

export function useCyclingPlaceholder(): {
  chatPlaceholderStyle: React.CSSProperties;
} {
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [typedPlaceholder, setTypedPlaceholder] = useState("");

  useEffect(() => {
    let cancelled = false;
    const phrase = CYCLING_PLACEHOLDERS[placeholderIndex] ?? "";

    const TYPE_DELAY = 28;
    const DELETE_DELAY = 16;
    const START_DELAY = 250;
    const DWELL_AFTER = 3000;

    let charIndex = 0;
    let typeTimer: number | undefined;
    let dwellTimer: number | undefined;
    let deleteTimer: number | undefined;

    const typeStep = () => {
      if (cancelled) {
        return;
      }
      requestAnimationFrame(() => {
        if (cancelled) {
          return;
        }
        setTypedPlaceholder(phrase.slice(0, charIndex + 1));
      });
      charIndex += 1;
      if (charIndex < phrase.length) {
        typeTimer = window.setTimeout(typeStep, TYPE_DELAY);
      } else {
        dwellTimer = window.setTimeout(deletePhase, DWELL_AFTER);
      }
    };

    const deletePhase = () => {
      if (cancelled) {
        return;
      }
      const deleteStep = () => {
        if (cancelled) {
          return;
        }
        charIndex -= 1;
        requestAnimationFrame(() => {
          if (cancelled) {
            return;
          }
          setTypedPlaceholder(phrase.slice(0, charIndex));
        });
        if (charIndex > 0) {
          deleteTimer = window.setTimeout(deleteStep, DELETE_DELAY);
        } else {
          setPlaceholderIndex((i) => (i + 1) % CYCLING_PLACEHOLDERS.length);
        }
      };
      deleteStep();
    };

    const startTimer = window.setTimeout(typeStep, START_DELAY);
    return () => {
      cancelled = true;
      window.clearTimeout(startTimer);
      if (typeTimer) {
        window.clearTimeout(typeTimer);
      }
      if (dwellTimer) {
        window.clearTimeout(dwellTimer);
      }
      if (deleteTimer) {
        window.clearTimeout(deleteTimer);
      }
    };
  }, [placeholderIndex]);

  const chatPlaceholderStyle = useMemo(() => {
    return {
      ["--chat-placeholder"]: JSON.stringify(typedPlaceholder),
    } as unknown as React.CSSProperties;
  }, [typedPlaceholder]);

  return { chatPlaceholderStyle };
}
